import moment from 'moment';

/**
 * Calculates the duration between two dates (inclusive).
 *
 * @param {string} period - A string representing the period (e.g., "Sep 2022 - Present")
 * @returns {string} A formatted string representing the duration (e.g., "1 year 2 months")
 */
function calculateDuration(period) {
  const [startDate, endDate] = period.split(' - ');
  const start = moment(startDate, 'MMM YYYY').startOf('month');
  const end = endDate === 'Present' ? moment().startOf('month') : moment(endDate, 'MMM YYYY').startOf('month');

  if (!start.isValid() || !end.isValid()) {
    return 'Invalid date';
  }

  // Calculate the difference in months (inclusive - both start and end months count)
  const totalMonths = end.diff(start, 'months') + 1;
  
  const years = Math.floor(totalMonths / 12);
  const months = totalMonths % 12;

  if (years > 0 && months > 0) {
    return `${years} year${years > 1 ? 's' : ''} ${months} month${months > 1 ? 's' : ''}`;
  } else if (years > 0) {
    return `${years} year${years > 1 ? 's' : ''}`;
  } else {
    return `${months} month${months > 1 ? 's' : ''}`;
  }
}

export default calculateDuration;
